<template>

  <li class="list-group-item">
    <div class="feed-item">
      <div class="feed-icon text-secondary">
        <i class="fas fa-undo" v-if="jobLog.fixed" />
        <i class="fas fa-map-pin" v-if="!jobLog.fixed" />
      </div>
      <div class="feed-content">
        <div
          class="photo"
          v-if="jobLog.author_user_id">
          <Avatar
            :src="imgSrc"
            :name="jobLog.author_user_id.name"
            size="40px"
            radius="20px"
            resize="100x100x1" />
        </div>
        <div class="content">

          <div
            class="feed-actions dropdown"
            v-if="!jobLog.fixed && !showEdit">
            <button
              class="btn btn-sm btn-light"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              <i class="fas fa-chevron-down" />
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button
                class="dropdown-item"
                @click="showEdit=true">
                  <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
                </button>
              <button
                class="dropdown-item"
                @click="deleteJobLog(jobLog)">
                  <i class="fas fa-times" /> {{ $t('Remove') }}
                </button>
            </div>
          </div>

          <span
            v-if="!showEdit"
            style="white-space: pre-wrap;">{{ jobLog.note }}</span>

          <job-log-form
            v-if="showEdit"
            :initValue="jobLog"
            :enableCancel="true"
            @updated="showEdit=false"
            @cancel="showEdit=false">
            </job-log-form>

          <div class="mt-2">
            <small>
              <span v-tooltip="$d(new Date(jobLog.created_at), 'long')">{{ jobLog.created_at | moment('fromNow', $i18n.locale) }}</span>,
              {{ jobLog.author_user_id.name }}
            </small>
          </div>
          
        </div>
      </div>
    </div>
  </li>

</template>

<script>
import JobLogForm from './JobLogForm'
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'JobLogItem',
  components: {
    JobLogForm,
    Avatar
  },
  props: [
    'jobLog'
  ],
  data () {
    return {
      loading: false,
      showEdit: false
    }
  },
  computed: {
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.jobLog.author_user_id.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    deleteJobLog (data) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteJobLog', {
          _id: data._id,
          job_id: data.job_id
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', data)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobLog/JobLogItem.vue